/*
 * Public API Surface of modulo-solicitudes
 */

export * from './lib/modulo-solicitudes.service';
export * from './lib/modulo-solicitudes.component';
export * from './lib/modulo-solicitudes.module';
export * as ModuloDos from './solicitudes/solicitudes.module';
